<!-- THIS IS A TEMPLATE TO COPY AND PASTE -->
<div style="width: 900px; height: 600px;" data-cy="sleuth-wizard-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="sleuth-wizard-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="sleuth-wizard-header">
      <div class="section-header-title" data-cy="sleuth-wizard-title">
        Sleuth Wizard
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; padding-top: 3px;" data-cy="sleuth-wizard-content">
      <div style="flex: 1; padding: 4px; display: flex; flex-direction: column;" data-cy="sleuth-wizard-b-column">
        <div style="flex-basis: 14px; background-color: var(--tdo-secondary-accent); text-align: center;" data-cy="sleuth-wizard-b-title">B</div>
        <div style="flex: 1; display: flex; flex-direction: column;" data-cy="sleuth-wizard-b-options">
          @for (enu of sleuthBEnums; track enu) {
            <div (click)="data.enumEndoPainToothSleuthBID = enu.ValidValueItemId" class="slueth-wizard-item" [ngClass]="{'slueth-wizard-item-selected': isSelected(enu, 'B')}" data-cy="sleuth-wizard-b-item">{{enu.ItemDisplayValue}}</div>
          }
        </div>
      </div>
      <div style="flex: 1; padding: 4px; display: flex; flex-direction: column;" data-cy="sleuth-wizard-l-column">
        <div style="flex-basis: 14px; background-color: var(--tdo-secondary-accent); text-align: center;" data-cy="sleuth-wizard-l-title">L</div>
        <div style="flex: 1; display: flex; flex-direction: column;" data-cy="sleuth-wizard-l-options">
          @for (enu of sleuthBEnums; track enu) {
            <div (click)="data.enumEndoPainToothSleuthLID = enu.ValidValueItemId" class="slueth-wizard-item" [ngClass]="{'slueth-wizard-item-selected': isSelected(enu, 'L')}" data-cy="sleuth-wizard-l-item">{{enu.ItemDisplayValue}}</div>
          }
        </div>
      </div>
      <div style="flex: 1; padding: 4px; display: flex; flex-direction: column;" data-cy="sleuth-wizard-mb-column">
        <div style="flex-basis: 14px; background-color: var(--tdo-secondary-accent); text-align: center;" data-cy="sleuth-wizard-mb-title">MB</div>
        <div style="flex: 1; display: flex; flex-direction: column;" data-cy="sleuth-wizard-mb-options">
          @for (enu of sleuthBEnums; track enu) {
            <div (click)="data.enumEndoPainToothSleuthMBID = enu.ValidValueItemId" class="slueth-wizard-item" [ngClass]="{'slueth-wizard-item-selected': isSelected(enu, 'MB')}" data-cy="sleuth-wizard-mb-item">{{enu.ItemDisplayValue}}</div>
          }
        </div>
      </div>
      <div style="flex: 1; padding: 4px; display: flex; flex-direction: column;" data-cy="sleuth-wizard-ml-column">
        <div style="flex-basis: 14px; background-color: var(--tdo-secondary-accent); text-align: center;" data-cy="sleuth-wizard-ml-title">ML</div>
        <div style="flex: 1; display: flex; flex-direction: column;" data-cy="sleuth-wizard-ml-options">
          @for (enu of sleuthBEnums; track enu) {
            <div (click)="data.enumEndoPainToothSleuthMLID = enu.ValidValueItemId" class="slueth-wizard-item" [ngClass]="{'slueth-wizard-item-selected': isSelected(enu, 'ML')}" data-cy="sleuth-wizard-ml-item">{{enu.ItemDisplayValue}}</div>
          }
        </div>
      </div>
      <div style="flex: 1; padding: 4px; display: flex; flex-direction: column;" data-cy="sleuth-wizard-db-column">
        <div style="flex-basis: 14px; background-color: var(--tdo-secondary-accent); text-align: center;" data-cy="sleuth-wizard-db-title">DB</div>
        <div style="flex: 1; display: flex; flex-direction: column;" data-cy="sleuth-wizard-db-options">
          @for (enu of sleuthBEnums; track enu) {
            <div (click)="data.enumEndoPainToothSleuthDBID = enu.ValidValueItemId" class="slueth-wizard-item" [ngClass]="{'slueth-wizard-item-selected': isSelected(enu, 'DB')}" data-cy="sleuth-wizard-db-item">{{enu.ItemDisplayValue}}</div>
          }
        </div>
      </div>
      <div style="flex: 1; padding: 4px; display: flex; flex-direction: column;" data-cy="sleuth-wizard-dl-column">
        <div style="flex-basis: 14px; background-color: var(--tdo-secondary-accent); text-align: center;" data-cy="sleuth-wizard-dl-title">DL</div>
        <div style="flex: 1; display: flex; flex-direction: column;" data-cy="sleuth-wizard-dl-options">
          @for (enu of sleuthBEnums; track enu) {
            <div (click)="data.enumEndoPainToothSleuthDLID = enu.ValidValueItemId" class="slueth-wizard-item" [ngClass]="{'slueth-wizard-item-selected': isSelected(enu, 'DL')}" data-cy="sleuth-wizard-dl-item">{{enu.ItemDisplayValue}}</div>
          }
        </div>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="sleuth-wizard-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="sleuth-wizard-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="sleuth-wizard-ok-button">Ok</button>
    </div>
  </div>
</div>
